module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page vertical-align text-xs-center"
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace))
    }
  }, [_vm._v("\n      GO TO DASHBOARD\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', {
    staticClass: "animation-slide-top"
  }, [_vm._v("404")]), _vm._v(" "), _c('h4', {
    staticClass: "blue-grey-400"
  }, [_vm._v("Sorry , Page not found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9cc86a90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/Page404.vue
// module id = 555
// module chunks = 1